import styled from "styled-components";

const LinkStyle = styled.a`
  text-decoration: none;
`;

const LogoContainerStyle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 5rem;
  background: linear-gradient(
    90deg,
    rgba(238, 109, 152, 1) 15%,
    rgba(138, 94, 191, 1) 85%
  );

  .logoContainer {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    width: 80%;
    height: 80%;
    border-radius: 7px;
    background: rgba(255, 255, 255, 0.25);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
  }
`;

export { LinkStyle, LogoContainerStyle };

//ignore this comment
